import { connect } from 'react-redux'
import { requestAllData } from '../../actions/index.js';
import BackgroundVideo from '../../components/general/BackgroundVideo.jsx';
import LoadingText from '../../components/general/Loading.jsx';
import requestStatus from '../../constants/requestStatus.js';
import { LOAD_ALL_LOADED, LOAD_ALL_STATUS } from '../../constants/state.js';
import getData from '../../functions/getData.js';
import toJS from '../general/toJS.js'

const mapStateToProps = state => ({
    status: getData(state, LOAD_ALL_STATUS),
    loaded: getData(state, LOAD_ALL_LOADED)
})

const mapDispatchToProps = dispatch => ({
    onLoadData: () => {
        dispatch(requestAllData())
    }
})

const WrapperLoadingPage = ({status, loaded, children, onLoadData}) => (
    <>
        {loaded ? (
            children
        ) : (
            <div className='full-width-spinner'>
                <BackgroundVideo />
                <LoadingText
                    error={requestStatus.REQUEST_ERROR === status}
                    onLoadData={onLoadData}
                />
            </div>
        )}
    </>
)

export default connect(mapStateToProps, mapDispatchToProps)(toJS(WrapperLoadingPage))